export enum AngleTypeEnum {
  straight,
  rounded,
}
